
import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const SHIPPERS_BASE = "/shippers";
const buildUrl = (endpoint) => SHIPPERS_BASE + endpoint;
const ApiName = "Shippers";


const shippersApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        getShippers: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}` , identifier: 'datatable'}],
            onQueryStarted: muiDataGridStarted.bind(null, 'getShippers', `${ApiName}`)
        }),
        getShippersSelect: builder.query({
            query: (args) => ({
                url: buildUrl(`/select`),
                method: 'POST',
                body: args
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}`, identifier: `select-${arg?.warehouseId ?? 0}` }],
        }),
        getShippersSelectWithProfiles: builder.query({
            query: (args) => ({
                url: buildUrl(`/selectprofiles`),
                method: 'POST',
                body: args
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}`, identifier: `select-${arg?.warehouseId ?? 0}` }],
        }),
        getShipper: builder.query({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg }]
        }),
        getShipperProfilesSelect: builder.query({
            query: shipperId => ({
                url: buildUrl(`/profiles/select/${shipperId}`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg }]
        }),
        addNewShipper: builder.mutation({
            query: shipperInfo => {
                
                return {
                    url: buildUrl(`/new`),
                    method: 'POST',
                    body: shipperInfo,
                }
            },
            invalidatesTags: [`${ApiName}`],
        }),
        editShipper: builder.mutation({
            query: shipperInfo => ({
                url: buildUrl(`/${shipperInfo.id}`),
                method: 'PUT',
                body: shipperInfo,
            }),
            invalidatesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg.id }, {type: `${ApiName}`}],
        }),
        deleteShipper: builder.mutation({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'DELETE'
            }),
            invalidatesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg.id }, {type: `${ApiName}`}],
        }),
        getConfigInfo: builder.query({
            query: (arg) => {
                // Accept either a plain shipper id or an object { id, returns, relationId }.
                // Return profiles request the returns=true variant of the config info.
                // A relationId fetches the config info with that relation's own key.
                const id = typeof arg === 'object' && arg !== null ? arg.id : arg;
                const returns = typeof arg === 'object' && arg !== null ? arg.returns : false;
                const relationId = typeof arg === 'object' && arg !== null ? arg.relationId : null;
                const params = new URLSearchParams();
                if (returns) params.set('returns', 'true');
                if (relationId) params.set('relationId', relationId);
                const queryString = params.toString();
                return {
                    url: buildUrl(`/${id}/configinfo${queryString ? `?${queryString}` : ''}`),
                    method: 'GET'
                };
            },

        }),
        testDHLGermanyConnection: builder.mutation({
            query: (shipperData) => ({
                url: buildUrl('/test-dhl-germany-connection'),
                method: 'POST',
                body: shipperData
            }),
            transformResponse: (response) => response.data,
            transformErrorResponse: (response) => response.data
        }),
        validateDHLGermanyProfile: builder.mutation({
            query: (profileData) => ({
                url: '/shipper-profiles/validate-dhl-germany',
                method: 'POST',
                body: profileData
            }),
            transformResponse: (response) => response.data,
            transformErrorResponse: (response) => response.data
        }),
        testShipperConnection: builder.mutation({
            query: ({ shipperType, credentials, timeout = 30000 }) => ({
                url: buildUrl('/test-connection'),
                method: 'POST',
                body: { 
                    shipperType, 
                    credentials,
                    timeout
                }
            })
        }),
        syncSenderCodes: builder.mutation({
            query: id => ({
                url: buildUrl(`/${id}/sendercodes`),
                method: 'POST'
            }),
            invalidatesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg }],
        }),
        getExternalObjects: builder.query({
            query: ({id, type}) => ({
                url: buildUrl(`/${id}/objects/${type}`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg }]
        }),
    })
});

export const {
    useGetShippersQuery,
    useGetShippersSelectQuery,
    useGetShippersSelectWithProfilesQuery,
    useGetShipperQuery,
    useAddNewShipperMutation,
    useEditShipperMutation,
    useDeleteShipperMutation,
    useGetConfigInfoQuery,
    useTestDHLGermanyConnectionMutation,
    useValidateDHLGermanyProfileMutation,
    useTestShipperConnectionMutation,
    useGetExternalObjectsQuery,
    useSyncSenderCodesMutation,
    useGetShipperProfilesSelectQuery
  } = shippersApiSlice;